import axios from "axios";
import logger from '../utils/logger';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  timeout: 500000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Refactored request interceptor
instance.interceptors.request.use((config) => {
  // Conditionally log for debugging in development environment
  // if (process.env.NODE_ENV === "development") {
  logger("log", "API Base URL:", process.env.REACT_APP_BASE_URL);
  // }

  // Check both session and local storage for the token, just like in authServices.js
  const token = localStorage.getItem("token");

  if (token) {
    // Modify headers on the existing config object
    config.headers.Authorization = `Bearer ${token}`;
    // The original code had a custom 'rlinks-token'. Correcting to 'rlink-token' for consistency.
    config.headers["rlink-token"] = token;
  }

  // Handle FormData - let browser set Content-Type with boundary
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url) => instance.get(url).then(responseBody),

  blob: (url) => instance.get(url, { responseType: "blob" }).then(responseBody),

  post: (url, body, config) =>
    instance.post(url, body, config).then(responseBody),

  put: (url, body) => instance.put(url, body).then(responseBody),

  delete: (url, config) => instance.delete(url, config).then(responseBody),

  patch: (url, body, config) =>
    instance.patch(url, body, config).then(responseBody),
};

export default requests;
